// src/components/About.js
import React from 'react';

const About = () => {
    return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
            <h1>About 18Overview</h1>
            <p>
                18Overview is a platform designed to help golfers discover and explore private golf courses across the United States.
                Whether you're a seasoned golfer or just getting into the sport, our goal is to provide valuable information about each course,
                including detailed course overviews, amenities, membership requirements, fees, and other important details.
            </p>
            <p>
                Our mission is to make it easier for golf enthusiasts to find the right private club that fits their preferences, location, and lifestyle.
                We aim to provide up-to-date and accurate information, using AI to generate course summaries and ensure you get the best insights into
                the golfing experience available at each course.
            </p>
            <p>
                Thank you for choosing 18Overview as your trusted golf course directory.
            </p>
        </div>
    );
};

export default About;
